const REQUEST_PPT_DATA = '@@ppt/REQUEST_PPT_DATA';
const PPT_DATA_RESPONSE = '@@ppt/PPT_DATA_RESPONSE';
const GAME_DATA_RESPONSE = '@@ppt/GAME_DATA_RESPONSE';
const TEAM_DATA_RESPONSE = '@@ppt/TEAM_DATA_RESPONSE';

export default {
    REQUEST_PPT_DATA,
    PPT_DATA_RESPONSE,
    GAME_DATA_RESPONSE,
    TEAM_DATA_RESPONSE,
};
